import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["rateForm", "rateInput"];

  connect() {
    this.savedRate = this.rateInputTarget.value;
    this.savingRate = false;
  }

  clearRateError() {
    this.rateInputTarget.setCustomValidity("");
  }

  editRate() {
    this.rateInputTarget.value = this.rateInputTarget.value.replace(
      /[$,]/g,
      ""
    );
    this.rateInputTarget.select();
  }

  cancelRate(event) {
    event.preventDefault();
    if (this.savingRate) return;
    this.rateInputTarget.value = this.savedRate;
    this.rateInputTarget.setCustomValidity("");
    this.rateInputTarget.blur();
  }

  saveRate(event) {
    event.preventDefault();
    if (this.savingRate) return;

    const input = this.rateInputTarget;
    const value = input.value.trim();
    input.setCustomValidity("");
    if (
      value &&
      !/^\$?\s*(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?$/.test(value)
    ) {
      input.setCustomValidity("Enter an amount, such as 1,200.00.");
      input.reportValidity();
      return;
    }

    const number = (text) =>
      text === "" ? "" : Number(text.replace(/[$,]/g, ""));
    if (number(value) === number(this.savedRate)) {
      input.value = this.savedRate;
      if (event.type === "keydown") input.blur();
      return;
    }

    this.savingRate = true;
    input.readOnly = true;
    input.blur();
    this.rateFormTarget.classList.add("loading");
    this.rateFormTarget.requestSubmit();
  }

  finishRateSave(event) {
    this.savingRate = false;
    this.rateInputTarget.readOnly = false;
    this.rateFormTarget.classList.remove("loading");
    if (!event.detail.success) {
      this.rateInputTarget.setCustomValidity(
        "Couldn't save the rate. Try again."
      );
      this.rateInputTarget.reportValidity();
    }
  }
}
